module.exports = __webpack_public_path__ + "static/media/Verfied.3a0a2f2c.png";